import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import {
  CoreMappingsBuyersResponseDto,
  CoreMappingsUploadResponseDto,
} from './dtos/core-mappings.dto';

@Injectable({ providedIn: 'root' })
export class CoreMappingsApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);
  private readonly _baseUrl = this._env.pureSpectrum.url;

  public getBuyers(): Observable<CoreMappingsBuyersResponseDto> {
    return this._http.get<CoreMappingsBuyersResponseDto>(
      `${this._baseUrl}/getBuyers`,
    );
  }

  public uploadMappings(
    file: File,
    buyerId: string,
  ): Observable<CoreMappingsUploadResponseDto> {
    const formData = new FormData();
    formData.append('mappings', file);
    return this._http.post<CoreMappingsUploadResponseDto>(
      `${this._baseUrl}/suppliers/v2/mappings/upload/${buyerId}`,
      formData,
    );
  }

  public downloadMappings(buyerId: string): Observable<Blob> {
    return this._http.get(`${this._baseUrl}/suppliers/v2/mappings/${buyerId}`, {
      responseType: 'blob',
    });
  }
}
